import MpGroup from './views/MpGroup.vue';
import WxTpl from './views/WxTpl.vue';
import Broadcast from './views/Broadcast.vue';
import Admin from './views/Admin.vue';
import Records from './views/Records.vue';
import Subscribe from './views/Subscribe.vue';

export default [
  {
    path: 'mpgroup',
    component: MpGroup,
    name: '公众号群发',
  },
  {
    path: 'wxtpl',
    component: WxTpl,
    name: '模板消息',
  },
  {
    path: 'broadcast',
    component: Broadcast,
    name: '广播',
  },
  {
    path: 'subscribe',
    component: Subscribe,
    name: '订阅通知',
  },
  {
    path: 'admin',
    component: Admin,
    name: '管理员',
  },
  {
    path: 'records',
    component: Records,
    name: '群发记录',
  },
];
